'use client';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { AdditionalBenefitsTowardsCustomerSatisfaction } from './additional-benefits-towards-customer-satisfaction';
import { Banner } from './banner';
import { ContactUsForMoreDetails } from './contact-us-for-more-details';
import { HowLongDoesTheLifetimeWarrantyLast } from './how-long-does-the-lifetime-warranty-last';
import { LinkGroup } from './link-group';
import { OneUnconditionalFreeReplacement } from './one-unconditional-free-replacement';
import { WarrantyRegisteration } from './warranty-registeration';
import { WarrantyRegisterationForm } from './warranty-registeration-form';
import { WhatDoesTheLifetimeWarrantyCover } from './what-does-the-lifetime-warranty-cover';

export const WarrantyPageNew = () => {
  const { isMobile } = useIsMobile();
  const componentsList = isMobile
    ? [
        LinkGroup,
        HowLongDoesTheLifetimeWarrantyLast,
        WhatDoesTheLifetimeWarrantyCover,
        WarrantyRegisteration,
        AdditionalBenefitsTowardsCustomerSatisfaction,
        OneUnconditionalFreeReplacement,
        WarrantyRegisterationForm,
        ContactUsForMoreDetails,
      ]
    : [
        LinkGroup,
        HowLongDoesTheLifetimeWarrantyLast,
        WhatDoesTheLifetimeWarrantyCover,
        WarrantyRegisteration,
        OneUnconditionalFreeReplacement,
        AdditionalBenefitsTowardsCustomerSatisfaction,
        WarrantyRegisterationForm,
        ContactUsForMoreDetails,
      ];

  return (
    <div className=' font-roboto-regular text-primary'>
      <Banner />

      <div className='personalContent gont-normal mx-auto px-[12px] pb-[20px] font-roboto-regular text-[16px] leading-[24px] lg_px-0 lg_pb-[60px] lg_text-[18px] lg_leading-[30px]'>
        At HISEA, we stand behind the quality and durability of our products. That’s why we offer a Lifetime Warranty on
        every pair of boots. We believe in creating products that are built to last and designed for the rugged
        outdoors. Our Lifetime Warranty reflects our confidence in HISEA’s craftsmanship and our commitment to your
        satisfaction. When you choose HISEA, you’re not just buying boots—you’re investing in years of adventure, backed
        by our commitment to quality and service.
      </div>
      {componentsList.map((Component, index) => (
        <Component key={index} />
      ))}

      {/* <LinkGroup />

      <HowLongDoesTheLifetimeWarrantyLast />

      <WhatDoesTheLifetimeWarrantyCover />

      <WarrantyRegisteration />

      <OneUnconditionalFreeReplacement />

      <AdditionalBenefitsTowardsCustomerSatisfaction />

      <WarrantyRegisterationForm />

      <ContactUsForMoreDetails /> */}
    </div>
  );
};
